var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 51,
    fill: "none",
    viewBox: "0 0 51 51",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M21.3542 51.0001C33.1477 51.0001 42.7083 41.4395 42.7083 29.6459C42.7083 17.8523 33.1477 8.29175 21.3542 8.29175C9.56059 8.29175 0 17.8523 0 29.6459C0 41.4395 9.56059 51.0001 21.3542 51.0001ZM22.0357 27.8929L28 20.6879V20.6858L26.4279 19.2917L21 25.848L15.5721 19.2939L14 20.6879L19.9643 27.8929V28.5685H15.8217V29.6408V30.7131H19.9643V31.7854H15.8217V32.8578V33.9301H19.9643V39.2917H21H22.0357V33.9301H26.1783V32.8578V31.7854H22.0357V30.7131H26.1783V29.6408V28.5685H22.0357V27.8929Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M43.303 37.8839C47.4266 33.9906 50.0001 28.4729 50.0001 22.3542C50.0001 10.5606 40.4395 1 28.6459 1C22.5272 1 17.0095 3.57346 13.1162 7.69706C15.6791 6.73469 18.4552 6.20833 21.3543 6.20833C34.2984 6.20833 44.7918 16.7017 44.7918 29.6458C44.7918 32.5449 44.2654 35.321 43.303 37.8839Z",
    clipRule: "evenodd",
    opacity: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYen);
export default __webpack_public_path__ + "static/media/yen.cd4e7aa2e06024c7c385323bc8bdb935.svg";
export { ForwardRef as ReactComponent };